import { render, staticRenderFns } from "./switchview.vue?vue&type=template&id=12436889"
import script from "./switchview.vue?vue&type=script&lang=js"
export * from "./switchview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports